// extracted by mini-css-extract-plugin
export default {"robot-icon":"g__robot-icon--dvyUw","content":"g__content--K7NFM"};